export const FULLFILL_PATIENT = 'FULLFILL_PATIENT'
export const FULLFILL_PATIENTS = 'FULLFILL_PATIENTS'
export const SET_VALIDATION_ERRORS = 'SET_VALIDATION_ERRORS'
export const RESET_VALIDATION_ERRORS_BY_FIELD = 'RESET_VALIDATION_ERRORS_BY_FIELD'

export const SET_EDITED_PATIENT = 'SET_EDITED_PATIENT'
export const UPDATE_EDITED_PATIENT_FIELD = 'UPDATE_EDITED_PATIENT_FIELD'
export const UPDATE_EDITED_PATIENT_VALIDATION = 'UPDATE_EDITED_PATIENT_VALIDATION'

export const SET_CREATION_PATIENT = 'SET_CREATION_PATIENT'
export const UPDATE_CREATION_PATIENT_FIELD = 'UPDATE_CREATION_PATIENT_FIELD'
export const UPDATE_CREATION_PATIENT_VALIDATION = 'UPDATE_CREATION_PATIENT_VALIDATION'

export const CHANGE_FILTER_VALUE = 'CHANGE_FILTER_VALUE'
export const RESET_PAGE = 'RESET_PAGE'
export const CHANGE_DATA_TABLE_OPTIONS = 'CHANGE_DATA_TABLE_OPTIONS'
